export const ERROR_MESSAGES = {
  INVALID_FORM: 'Ошибка: Форма заполнена неверно, проверьте, пожалуйста, ошибки',
} as const;
